export default __webpack_public_path__ + "static/excel-1c8e0ea2f3bec49e45323fc77c853412.png";